<template>
  <MediaHeader />
  <slot />
</template>

<script setup>

</script>